import { css } from 'styled-components';
export var textEllipsis = css(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);